import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-kendo-grid-refresh-button',
  templateUrl: './kendo-grid-refresh-button.component.html',
  styleUrls: ['./kendo-grid-refresh-button.component.scss'],
})
export class KendoGridRefreshButtonComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
